/* eslint-disable unicorn/filename-case -- TODO rename later */
export enum ResourceType {
  Artifact = "artifact",
  Comment = "comment",
  Document = "document",
  Function = "function",
  Job = "job",
  Model = "model",
  System = "system",
  User = "user",
}
